import React, {useEffect, useState} from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {DateCalendar} from '#Client/components/DateCalendar/DateCalendar';
import {Modal} from '#Client/components/Modal/Modal';
import {Solution} from '#Client/components/SolutionsModal/Solution';
import {getYesterdaySolutions, PuzzleSolution} from '#Common/api/api';

type SolutionsModalProps = {
  onClose: () => void;
};

const labels = ['Easy', 'Medium', 'Hard', 'Brutal'];
export const SolutionsModal = ({onClose}: SolutionsModalProps) => {
  const [yesterdaySolutions, setYesterdaySolutions] = useState<
    PuzzleSolution[]
  >([]);
  useEffect(() => {
    (async () => {
      const yesterdaySolutions = await getYesterdaySolutions();
      const {puzzleEasy, puzzleMedium, puzzleHard, puzzleBrutal} =
        yesterdaySolutions;
      setYesterdaySolutions([
        puzzleEasy,
        puzzleMedium,
        puzzleHard,
        puzzleBrutal,
      ]);
    })();
  }, []);
  return (
    <Modal
      image={`${IMG_DIR}icon_calendar.png`}
      title="Past Solutions"
      onClose={onClose}
    >
      {yesterdaySolutions.length === 0 ? (
        <div>Loading...</div>
      ) : (
        <>
          <h2>
            Solutions For <DateCalendar date={yesterdaySolutions[0].Date} />
          </h2>
          {yesterdaySolutions.map((puzzle: PuzzleSolution, index: number) => (
            <Solution key={index} label={labels[index]} puzzle={puzzle} />
          ))}
        </>
      )}
    </Modal>
  );
};
